/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnitType
 */
export interface UnitType {
    /**
     * 
     * @type {string}
     * @memberof UnitType
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof UnitType
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof UnitType
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof UnitType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UnitType
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof UnitType
     */
    color?: string;
}

/**
 * Check if a given object implements the UnitType interface.
 */
export function instanceOfUnitType(value: object): value is UnitType {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UnitTypeFromJSON(json: any): UnitType {
    return UnitTypeFromJSONTyped(json, false);
}

export function UnitTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnitType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'name': json['name'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function UnitTypeToJSON(json: any): UnitType {
    return UnitTypeToJSONTyped(json, false);
}

export function UnitTypeToJSONTyped(value?: UnitType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'name': value['name'],
        'icon': value['icon'],
        'color': value['color'],
    };
}

